import { ENV } from '@configs/env';
import { getUserAvatarPath, getUserAvatarUrl } from '@utils/userAvatar';

/** Resolve API avatar path to a full URL for display. */
export function resolveChatAvatarUrl(path) {
    if (!path) return null;
    return getUserAvatarUrl({ avatarUrl: path }, ENV.API_URL);
}

/** Participant / user record from chat APIs. */
export function getParticipantAvatarPath(entity) {
    if (!entity) return null;
    return getUserAvatarPath(entity) ?? entity?.senderAvatarUrl ?? entity?.sender_avatar_url ?? null;
}

/** Prefer message.senderAvatarUrl, else match chat participant by senderId. */
export function getMessageSenderAvatarPath(message, participants = []) {
    if (!message) return null;
    const fromMsg = message.senderAvatarUrl ?? message.sender_avatar_url ?? null;
    if (fromMsg) return fromMsg;

    const senderId = message.senderId ?? message.userId ?? message.createdBy;
    if (senderId == null || senderId === '') return null;

    const participant = (Array.isArray(participants) ? participants : []).find(
        (p) => String(p.userId ?? p.id) === String(senderId),
    );
    return getParticipantAvatarPath(participant);
}

export function resolveMessageSenderAvatarUrl(message, participants = []) {
    return resolveChatAvatarUrl(getMessageSenderAvatarPath(message, participants));
}

/**
 * Sidebar / list row: DM shows the other participant's avatar; groups/channels keep initials only.
 */
export function resolveChatListItemAvatarUrl(chat, currentUserId) {
    if (!chat) return null;
    const participants = chat.participants ?? [];
    const others = participants.filter((p) => String(p.userId ?? p.id) !== String(currentUserId));
    if (others.length !== 1) return null;
    return resolveChatAvatarUrl(getParticipantAvatarPath(others[0]));
}

/** DM header: avatar of the other participant. */
export function resolveDmHeaderAvatarUrl(chat, currentUserId) {
    return resolveChatListItemAvatarUrl(chat, currentUserId);
}
